<template>
  <div class="pantalla-wrapper">
    <SweetAlert ref="SweetAlert" />

    <div class="d-flex justify-content-end my-2 gap-2">
      <button type="button" class="btn btn-outline-main btn-sm" :disabled="loading" @click="mtdGetData">
        <i class="fas fa-sync-alt"></i> Actualizar
      </button>
      &nbsp;
      <button type="button" class="btn btn-success btn-sm" :disabled="sendingWsp" @click="mtdSendWhatsapp">
        <i :class="sendingWsp ? 'fas fa-spinner fa-spin' : 'fab fa-whatsapp'"></i>
        {{ sendingWsp ? "Enviando..." : "Enviar por WhatsApp" }}
      </button>
    </div>

    <div class="pantalla-board">
      <!-- Encabezado -->
      <div class="pantalla-header">
        <!-- <div class="logo-block">
          <div class="logo-diamond"></div>
          <div class="logo-text">
            <span class="logo-title">BM</span>
            <span class="logo-sub">Clínica</span>
          </div>
        </div> -->

        <div class="pantalla-title">
          <h2>PACIENTES UNIDAD DE CUIDADOS INTENSIVOS</h2>
        </div>

        <div class="pantalla-date">
          <h3>{{ mtdToday }}</h3>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered pantalla-table mb-0">
          <thead>
            <tr>
              <th style="width: 6%">CAMA</th>
              <th style="width: 18%">PACIENTE</th>
              <th style="width: 6%">EDAD</th>
              <th style="width: 20%">DIAGNOSTICO</th>
              <th style="width: 13%">ESPECIALIDAD</th>
              <th style="width: 12%">
                PROGRAMACION<br />DE CIRUGIA
              </th>
              <th style="width: 9%">N&deg; HCL</th>
              <th style="width: 8%">FECHA</th>
              <th style="width: 8%">GUARDAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="9" class="py-4">
                <i class="fas fa-spinner fa-spin"></i> Cargando...
              </td>
            </tr>
            <tr v-else-if="data.length == 0">
              <td colspan="9" class="py-4">No hay camas configuradas</td>
            </tr>
            <tr v-for="(item, index) in data" :key="item.cama + '-' + index" v-else
              :class="{ 'fila-libre': item.libre }">
              <td class="fw-bold">{{ item.cama }}</td>

              <template v-if="item.libre">
                <td colspan="8" class="text-muted fst-italic">CAMA LIBRE</td>
              </template>

              <template v-else>
                <td class="text-start ps-2">{{ item.paciente }}</td>
                <td>{{ item.edad }}</td>
                <td class="text-start ps-2 diagnostico-cell">{{ item.diagnostico }}</td>
                <td>
                  <input type="text" class="form-control form-control-sm text-center" v-model="item.especialidad"
                    @change="mtdMarkDirty(index)" />
                </td>
                <td>
                  <input type="date" class="form-control form-control-sm text-center" v-model="item.programacion"
                    @change="mtdMarkDirty(index)" />
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm text-center" v-model="item.hcl"
                    @change="mtdMarkDirty(index)" />
                </td>
                <td>{{ item.fecha }}</td>
              </template>

              <td>
                <button v-if="!item.libre" type="button" class="btn btn-sm"
                  :class="item.dirty ? 'btn-success' : 'btn-outline-secondary'" :disabled="!item.dirty || item.saving"
                  @click="mtdSaveRow(item, index)">
                  <i :class="item.saving ? 'fas fa-spinner fa-spin' : 'fas fa-save'
                    "></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

/*** pdf to img */
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export default {
  name: "c-asistencial-hospitalizacion-pantalla",
  components: {
    SweetAlert,
  },
  props: {
    rolname: String,
  },
  data() {
    return {
      loading: false,
      sendingWsp: false,
      data: [],
    };
  },
  computed: {
    mtdToday: function () {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yy = String(now.getFullYear()).slice(-2);
      return `${dd}/${mm}/${yy}`;
    },
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post", "postWithFileSinBus"]),

    mtdGetData: function () {
      this.loading = true;
      this.get({
        url: this.$store.getters.get__url + "/Uciadulto/screenList",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data = (response.data || []).map((item) => ({
              ...item,
              dirty: false,
              saving: false,
            }));
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showError("Error al cargar la información");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mtdMarkDirty: function (index) {
      this.data[index].dirty = true;
    },

    mtdSaveRow: function (item, index) {
      this.data[index].saving = true;
      this.post({
        url: this.$store.getters.get__url + "/Uciadulto/screenUpdate",
        token: this.$store.getters.get__token,
        params: {
          row_id: item.row_id,
          source: item.source, // 'hospitalization' | 'emergency' | uci_adults
          patient_id: item.patient_id,
          hc_old: item.hcl,
          specialty: item.especialidad,
          surgery_programming: item.programacion, // 'YYYY-MM-DD' o null
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data[index].dirty = false;
            this.$refs.SweetAlert.showSuccess("Guardado correctamente");
          } else {
            this.$refs.SweetAlert.showError("No se pudo guardar");
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showError("Error al guardar");
        })
        .finally(() => {
          this.data[index].saving = false;
        });
    },

    /**
     * Genera el PDF del tablero (DomPDF, backend), lo convierte a
     * imágenes con pdfjsLib (mismo patrón que mtdaddall / pdfToImages)
     * y envía cada imagen al backend para que la reenvíe por WhatsApp.
     */
    mtdSendWhatsapp: async function () {
      try {
        this.sendingWsp = true;

        const pdfUrl =
          this.$store.getters.get__url + "/Uciadulto/screenPdf";

        const images = await this.pdfToImages(pdfUrl);

        for (const imageBlob of images) {
          await this.sendImageToBackend(imageBlob);
        }

        this.$refs.SweetAlert.showSuccess(
          "Tablero enviado por WhatsApp correctamente"
        );
      } catch (e) {
        console.log(e);
        this.$refs.SweetAlert.showError("Error al enviar por WhatsApp");
      } finally {
        this.sendingWsp = false;
      }
    },

    /**
     * Convierte un PDF (por URL) en un array de blobs PNG, uno por página.
     * Requiere pdfjsLib importado y con el worker configurado
     * (ver import * as pdfjsLib al inicio del archivo).
     */
    pdfToImages: async function (pdfUrl) {
      const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
      const totalPages = pdf.numPages;

      const images = [];

      for (let i = 1; i <= totalPages; i++) {
        const page = await pdf.getPage(i);

        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
          canvasContext: ctx,
          viewport,
        }).promise;

        const blob = await new Promise((resolve) => {
          canvas.toBlob((blob) => resolve(blob), "image/png", 1);
        });

        images.push(blob);
      }

      return images; // array de blobs
    },

    /**
     * Sube una imagen (blob) al endpoint que la reenvía por WhatsApp.
     */
    sendImageToBackend: async function (blob) {
      const formData = new FormData();
      formData.append("image", blob, "pantalla_hospitalizacion.png");

      return this.postWithFileSinBus({
        url:
          this.$store.getters.get__url +
          "/Uciadulto/sendScreenImage",
        token: this.$store.getters.get__token,
        formData: formData,
      });
    },
  },
};
</script>

<style scoped>
.pantalla-wrapper {
  width: 100%;
}

.pantalla-board {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.pantalla-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 2px solid #900052;
  flex-wrap: wrap;
  gap: 10px;
}

.logo-block {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-diamond {
  width: 20px;
  height: 20px;
  background: #900052;
  transform: rotate(45deg);
  border-radius: 3px;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1;
}

.logo-title {
  font-weight: 800;
  font-size: 1rem;
  color: #333;
}

.logo-sub {
  font-size: 0.6rem;
  color: #888;
  letter-spacing: 0.5px;
}

.pantalla-title {
  flex: 1;
  text-align: center;
}

.pantalla-title h2 {
  margin: 0;
  font-weight: 800;
  font-size: 1.4rem;
  color: #900052;
  letter-spacing: 1px;
}

.pantalla-date h3 {
  margin: 0;
  font-weight: 700;
  font-size: 1.2rem;
  color: #333;
}

.pantalla-table {
  margin: 0;
  text-align: center;
  vertical-align: middle;
  font-size: 0.85rem;
}

.pantalla-table thead th {
  background: #900052;
  color: #fff;
  font-weight: 700;
  vertical-align: middle;
  border-color: #a3316b;
  padding: 10px 6px;
  font-size: 0.78rem;
}

.pantalla-table tbody td {
  vertical-align: middle;
  padding: 6px;
  border-color: #e0e0e0;
}

.pantalla-table tbody tr:nth-child(even) {
  background: #faf5f8;
}

.pantalla-table tbody tr.fila-libre {
  background: #f5f5f5;
}

.pantalla-table input.form-control-sm {
  font-size: 0.8rem;
  padding: 2px 4px;
}

.pantalla-table .diagnostico-cell {
  white-space: pre-line;
}
</style>